import { Component, inject } from '@angular/core';
import { ClosetDoorsStandardService } from 'src/app/services/configurators-2d/applications/closet-doors-standard.service';
import { CurrentService } from 'src/app/services/current.service';

/**
 * Saisie des dimensions de l'encoche (hauteur et largeur de la baie).
 * Toute modification recharge les groupes de vantaux disponibles.
 */
@Component({
  selector: 'ng-closet-doors-standard-door-recess',
  templateUrl: './recess.component.html',
  styleUrls: ['./recess.component.scss'],
})
export class ClosetDoorsStandardDoorRecessComponent {
  private readonly closetDoorsService = inject(ClosetDoorsStandardService);
  readonly current = inject(CurrentService);

  /** Largeur minimale possible tous panels confondus. */
  get globalMinWidth(): number {
    return this.closetDoorsService.globalMinWidth;
  }

  /** Largeur maximale possible tous panels confondus. */
  get globalMaxWidth(): number {
    return this.closetDoorsService.globalMaxWidth;
  }

  /**
   * Fonction de sélection de la hauteur des vantaux
   */
  selectDoorHeight(event: Event): void {
    this.current.closetDoors.doorHeight = Number((event.target as HTMLInputElement).value);
    this.loadPanels();
  }

  /**
   * Fonction de sélection de la largeur des vantaux
   */
  selectDoorWidth(event: Event): void {
    this.current.closetDoors.doorWidth = Number((event.target as HTMLInputElement).value);
    this.loadPanels();
  }

  /**
   * Réinitialise la sélection et recharge les groupes de vantaux
   * si les deux dimensions sont valides.
   */
  private loadPanels(): void {
    this.closetDoorsService.panelGroups = [];
    this.current.closetDoors.openingPercentage = undefined;
    this.current.closetDoors.doorNumber = undefined;

    const { doorHeight, doorWidth } = this.current.closetDoors;
    if (doorHeight > 0 && doorWidth > 0) {
      this.closetDoorsService.getPanels(doorHeight, doorWidth).then(groups => {
        this.closetDoorsService.panelGroups = groups;
      });
    }
  }
}
